import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { useUser } from "@clerk/clerk-react";
import Stats from "../components/Stats";

export const Route = createFileRoute("/stats")({
  component: RouteComponent,
});

function RouteComponent() {
  const { user } = useUser();
  const navigate = useNavigate();
  const hasAnalytics = user?.publicMetadata?.analytics ?? false;

  useEffect(() => {
    if (user && !hasAnalytics) navigate({ to: "/" });
  }, [user, hasAnalytics]);

  return (
    <div>
      <Stats />
    </div>
  );
}
